/**
 * This is a map from commerce product IDs to Ignite product IDs
 **/
const idMap = {
  '1026': 2450,
  '1027': 2444,
  '1028': 2451,
  '1118': 2405,
  '1119': 2407,
  '1363': 2417,
  '1373': 2401,
  '1379': 2402,
  '1390': 2420,
  '1394': 2402,
  '1397': 2422,
  '1398': 2422,
  '1399': 2422,
  '1400': 2422,
  '1401': 2422,
  '1402': 2422,
  '1403': 2422,
  '1404': 2422,
  '1405': 2422,
  '1406': 2422,
  '1407': 2422,
  '1408': 2422,
  '1410': 2422,
  '1411': 2422,
  '1413': 2422,
  '1415': 2422,
  '1417': 2422,
  '1419': 2422,
  '1421': 2422,
  '1424': 2422,
  '1425': 2422,
  '1426': 2422,
  '1427': 2422,
  '1428': 2422,
  '1429': 2422,
  '1431': 2422,
  '1432': 2423,
  '1435': 2423,
  '1438': 2423,
  '1441': 2423,
  '1444': 2423,
  '1447': 2423,
  '1453': 2422,
  '1456': 2422,
  '1459': 2422,
  '1462': 2422,
  '1465': 2422,
  '1468': 2422,
  '1471': 2422,
  '1474': 2422,
  '1477': 2422,
  '1478': 2422,
  '1481': 2422,
  '1484': 2422,
  '1485': 2423,
  '1488': 2423,
  '1491': 2423,
  '1494': 2423,
  '1497': 2423,
  '1500': 2423,
  '1506': 2422,
  '1509': 2422,
  '1510': 2422,
  '1511': 2423,
  '1517': 2422,
  '1520': 2422,
  '1521': 2422,
  '1522': 2423,
  '1528': 2422,
  '1531': 2422,
  '1534': 2422,
  '1537': 2422,
  '1540': 2422,
  '1543': 2422,
  '1546': 2422,
  '1549': 2422,
  '1552': 2422,
  '1555': 2422,
  '1558': 2422,
  '1561': 2422,
  '1564': 2422,
  '1567': 2422,
  '1570': 2422,
  '1573': 2422,
  '1576': 2422,
  '1579': 2422,
  '1582': 2422,
  '1585': 2422,
  '1588': 2422,
  '1591': 2422,
  '1594': 2422,
  '1597': 2422,
  '1601': 2453,
  '1622': 2422,
  '1623': 2422,
  '1625': 2422,
  '1627': 2422,
  '1629': 2422,
  '1630': 2422,
  '1631': 2422,
  '1632': 2422,
  '1633': 2422,
  '1634': 2422,
  '2003': 2422,
  '2004': 2422,
  '2005': 2422,
  '2006': 2422,
  '2008': 2422,
  '2009': 2422,
  '2010': 2422,
  '2011': 2422,
  '2012': 2422,
  '2013': 2422,
  '2014': 2422,
  '2015': 2422,
  '3226': 2433,
  '3227': 2433,
  '3228': 2433,
  '3229': 2433,
  '3230': 2433,
  '3231': 2433,
  '3232': 2433,
  '3233': 2433,
  '3234': 2433,
  '3235': 2433,
  '3236': 2433,
  '3237': 2433,
  '3238': 2433,
  '3239': 2433,
  '3240': 2433,
  '3241': 2433,
  '3242': 2433,
  '3243': 2433,
  '3244': 2433,
  '3245': 2433,
  '3246': 2433,
  '3247': 2433,
  '3248': 2433,
  '3249': 2433,
  '3250': 2433,
  '3251': 2433,
  '3252': 2433,
  '3253': 2433,
  '3254': 2433,
  '3255': 2433,
  '3256': 2433,
  '3257': 2433,
  '3258': 2433,
  '3259': 2433,
  '3260': 2433,
  '3261': 2433,
  '3262': 2433,
  '3263': 2433,
  '3264': 2433,
  '3265': 2433,
  '3266': 2433,
  '3267': 2433,
  '3268': 2433,
  '3269': 2433,
  '3270': 2433,
  '3271': 2433,
  '3272': 2433,
  '3273': 2433,
  '3274': 2433,
  '3275': 2433,
  '3276': 2433,
  '3277': 2433,
  '3278': 2433,
  '3279': 2433,
  '3280': 2433,
  '3281': 2433,
  '3282': 2433,
  '3283': 2433,
  '3284': 2433,
  '3285': 2433,
  '3286': 2433,
  '3287': 2433,
  '3288': 2433,
  '3289': 2433,
  '3290': 2433,
  '3291': 2433,
  '3292': 2433,
  '3293': 2433,
  '3294': 2433,
  '3295': 2433,
  '3296': 2433,
  '3297': 2433,
  '3298': 2433,
  '3299': 2433,
  '3300': 2433,
  '3301': 2433,
  '3302': 2433,
  '3303': 2433,
  '3304': 2433,
  '3305': 2433,
  '3306': 2433,
  '3307': 2433,
  '3308': 2433,
  '3309': 2433,
  '3310': 2433,
  '3311': 2433,
  '3312': 2433,
  '3313': 2433,
  '3314': 2433,
  '3315': 2433,
  '3316': 2433,
  '3317': 2433,
  '3318': 2433,
  '3319': 2433,
  '3320': 2433,
  '3321': 2433,
  '3322': 2433,
  '3323': 2433,
  '3324': 2433,
  '3325': 2433,
  '3326': 2433,
  '3327': 2433,
  '3328': 2433,
  '3329': 2433,
  '3330': 2433,
  '3331': 2433,
  '3332': 2433,
  '3333': 2433,
  '3334': 2433,
  '3335': 2433,
  '3336': 2433,
  '3337': 2433,
  '3338': 2433,
  '3339': 2433,
  '3340': 2433,
  '3341': 2433,
  '3342': 2433,
  '3343': 2433,
  '3344': 2433,
  '3345': 2433,
  '3346': 2433,
  '3347': 2433,
  '3348': 2433,
  '3349': 2433,
  '3350': 2433,
  '3351': 2433,
  '3352': 2433,
  '3353': 2433,
  '3354': 2433,
  '3355': 2433,
  '3356': 2433,
  '3357': 2433,
  '3358': 2433,
  '3359': 2433,
  '3360': 2433,
  '3361': 2433,
  '3362': 2433,
  '3363': 2433,
  '3364': 2433,
  '3365': 2433,
  '7557': 2411,
  '7559': 2411,
  '7916': 2422,
  '7917': 2423,
  '7922': 2422,
  '7923': 2422,
  '7924': 2422,
  '7925': 2422,
  '7926': 2422,
  '7927': 2422,
  '7928': 2422,
  '7929': 2422,
  '7972': 2400,
  '7973': 2421,
  '7983': 2422,
  '7984': 2422,
  '8174': 2422,
  '8175': 2422,
  '8176': 2423,
  '8177': 2423,
  '8178': 2422,
  '8179': 2422,
  '8207': 2422,
  '8208': 2423,
  '8218': 2422,
  '8219': 2422,
  '8220': 2429,
  '8222': 2429,
  '8224': 2429,
  '8226': 2429,
  '8228': 2429,
  '8230': 2429,
  '8233': 2429,
  '8235': 2429,
  '8236': 2429,
  '8237': 2429,
  '8239': 2429,
  '8242': 2429,
  '8243': 2429,
  '8245': 2429,
  '8246': 2429,
  '8272': 2429,
  '8274': 2429,
  '8282': 2429,
  '8283': 2429,
  '8284': 2429,
  '8285': 2429,
  '8286': 2429,
  '8287': 2429,
  '8288': 2429,
  '8292': 2429,
  '8293': 2429,
  '8294': 2429,
  '8297': 2432,
  '8298': 2432,
  '8299': 2432,
  '8300': 2432,
  '8301': 2432,
  '8302': 2432,
  '8303': 2432,
  '8304': 2432,
  '8305': 2432,
  '8306': 2432,
  '8307': 2432,
  '8308': 2432,
  '8309': 2425,
  '8310': 2425,
  '8313': 2425,
  '8314': 2425,
  '8317': 2425,
  '8318': 2425,
  '8327': 2428,
  '8328': 2428,
  '8331': 2428,
  '8332': 2428,
  '8339': 2426,
  '8340': 2426,
  '8343': 2427,
  '8344': 2427,
  '8347': 2427,
  '8348': 2427,
  '8353': 2429,
  '8355': 2429,
  '8357': 2429,
  '8358': 2429,
  '8361': 2429,
  '8362': 2429,
  '8365': 2429,
  '8366': 2429,
  '8367': 2429,
  '8368': 2429,
  '8369': 2429,
  '8375': 2429,
  '8377': 2429,
  '8379': 2429,
  '8383': 2429,
  '8385': 2429,
  '8387': 2429,
  '8388': 2429,
  '8389': 2429,
  '8390': 2429,
  '8391': 2429,
  '8392': 2429,
  '8393': 2429,
  '8394': 2429,
  '8395': 2429,
  '8396': 2429,
  '8397': 2429,
  '8398': 2429,
  '8399': 2429,
  '8401': 2429,
  '8402': 2429,
  '8403': 2429,
  '8404': 2429,
  '8405': 2429,
  '8407': 2429,
  '8409': 2429,
  '8411': 2429,
  '8413': 2429,
  '8415': 2429,
  '8417': 2429,
  '8419': 2429,
  '8421': 2429,
  '8423': 2429,
  '8425': 2447,
  '8431': 2447,
  '8435': 2447,
  '8439': 2447,
  '8441': 2447,
  '8443': 2447,
  '8444': 2447,
  '8445': 2447,
  '8446': 2447,
  '8447': 2447,
  '8448': 2447,
  '8449': 2447,
  '8450': 2447,
  '8451': 2447,
  '8452': 2447,
  '8453': 2447,
  '8454': 2447,
  '8455': 2447,
  '8457': 2447,
  '8458': 2447,
  '8459': 2447,
  '8460': 2447,
  '8461': 2447,
  '8463': 2447,
  '8465': 2447,
  '8467': 2447,
  '8469': 2447,
  '8471': 2447,
  '8473': 2447,
  '8475': 2447,
  '8477': 2447,
  '8479': 2447,
  '8481': 2429,
  '8482': 2429,
  '8483': 2429,
  '8484': 2429,
  '8485': 2429,
  '8486': 2429,
  '8487': 2429,
  '8489': 2429,
  '8490': 2429,
  '8491': 2429,
  '8492': 2429,
  '8493': 2429,
  '8494': 2429,
  '8495': 2429,
  '8496': 2429,
  '8497': 2429,
  '8498': 2429,
  '8499': 2429,
  '8500': 2429,
  '8501': 2429,
  '8503': 2429,
  '8504': 2429,
  '8505': 2429,
  '8506': 2429,
  '8507': 2429,
  '8509': 2429,
  '8511': 2429,
  '8513': 2429,
  '8515': 2429,
  '8517': 2429,
  '8519': 2429,
  '8521': 2429,
  '8523': 2429,
  '8525': 2429,
  '8527': 2445,
  '8531': 2445,
  '8533': 2445,
  '8535': 2445,
  '8537': 2445,
  '8539': 2445,
  '8541': 2445,
  '8543': 2445,
  '8545': 2445,
  '8546': 2445,
  '8547': 2445,
  '8548': 2445,
  '8549': 2445,
  '8550': 2445,
  '8551': 2445,
  '8552': 2445,
  '8553': 2445,
  '8554': 2445,
  '8555': 2445,
  '8556': 2445,
  '8557': 2445,
  '8559': 2445,
  '8560': 2445,
  '8561': 2445,
  '8562': 2445,
  '8563': 2445,
  '8565': 2445,
  '8567': 2445,
  '8569': 2445,
  '8571': 2445,
  '8573': 2445,
  '8575': 2445,
  '8577': 2445,
  '8579': 2445,
  '8581': 2445,
  '8583': 2431,
  '8584': 2431,
  '8585': 2431,
  '8586': 2431,
  '8587': 2429,
  '8597': 2431,
  '8598': 2431,
  '8599': 2431,
  '8600': 2431,
  '8601': 2431,
  '8602': 2431,
  '8603': 2431,
  '8604': 2429,
  '8608': 2431,
  '8609': 2431,
  '8610': 2431,
  '8611': 2431,
  '8612': 2429,
  '8614': 2429,
  '8616': 2429,
  '8618': 2429,
  '8620': 2429,
  '8622': 2429,
  '8624': 2429,
  '8626': 2429,
  '8627': 2429,
  '8628': 2429,
  '8629': 2429,
  '8632': 2429,
  '8633': 2429,
  '8636': 2429,
  '8637': 2429,
  '8638': 2429,
  '8640': 2429,
  '8641': 2429,
  '8644': 2429,
  '8645': 2429,
  '8646': 2429,
  '8647': 2429,
  '8648': 2429,
  '8650': 2429,
  '8652': 2429,
  '8654': 2429,
  '8656': 2429,
  '8658': 2429,
  '8660': 2429,
  '8662': 2429,
  '8664': 2429,
  '8666': 2429,
  '8668': 2429,
  '8670': 2431,
  '8671': 2431,
  '8672': 2431,
  '8673': 2431,
  '8674': 2431,
  '8675': 2431,
  '8676': 2431,
  '8677': 2431,
  '8679': 2429,
  '8680': 2429,
  '8686': 2429,
  '8687': 2427,
  '8693': 2427,
  '8699': 2429,
  '8700': 2447,
  '8702': 2445,
  '8704': 2429,
  '8706': 2429,
  '8708': 2426,
  '8709': 2429,
  '8710': 2447,
  '8712': 2445,
  '8714': 2426,
  '8716': 2447,
  '8720': 2428,
  '8723': 2429,
  '8725': 2429,
  '8726': 2428,
  '8727': 2429,
  '8729': 2429,
  '8730': 2445,
  '8731': 2429,
  '8732': 2429,
  '8735': 2429,
  '8737': 2429,
  '8770': 2422,
  '8771': 2422,
  '8772': 2423,
  '8773': 2423,
  '9265': 2422,
  '9266': 2422,
  '9340': 2429,
  '9342': 2429,
  '9343': 2429,
  '9344': 2429,
  '9345': 2429,
  '9347': 2429,
  '9348': 2429,
  '9349': 2429,
  '9350': 2429,
  '9351': 2429,
  '9352': 2429,
  '9353': 2429,
  '9355': 2429,
  '9356': 2429,
  '9357': 2429,
  '9358': 2429,
  '9372': 2429,
  '9377': 2429,
  '9384': 2429,
  '9389': 2422,
  '9390': 2423,
  '9391': 2423,
  '9399': 2423,
  '9400': 2422,
  '9402': 2422,
  '9403': 2422,
  '9404': 2422,
  '9409': 2422,
  '9424': 2422,
  '9425': 2422,
  '9516': 2422,
  '9550': 2433,
  '9551': 2433,
  '9552': 2433,
  '9553': 2433,
  '9554': 2433,
  '9555': 2433,
  '9556': 2433,
  '9557': 2433,
  '9558': 2433,
  '9559': 2433,
  '9560': 2433,
  '9561': 2433,
  '9562': 2433,
  '9563': 2433,
  '9564': 2433,
  '9565': 2433,
  '9566': 2433,
  '9567': 2433,
  '9568': 2433,
  '9569': 2433,
  '9570': 2433,
  '9571': 2433,
  '9572': 2433,
  '9573': 2433,
  '9574': 2433,
  '9575': 2433,
  '9576': 2433,
  '9577': 2433,
  '9578': 2433,
  '9579': 2433,
  '9580': 2433,
  '9581': 2433,
  '9582': 2433,
  '9583': 2433,
  '9584': 2433,
  '9585': 2433,
  '9586': 2433,
  '9587': 2433,
  '9588': 2433,
  '9589': 2433,
  '9590': 2433,
  '9591': 2433,
  '9592': 2433,
  '9593': 2433,
  '9594': 2433,
  '9595': 2433,
  '9596': 2433,
  '9597': 2433,
  '9598': 2433,
  '9599': 2433,
  '9600': 2433,
  '9601': 2433,
  '9602': 2433,
  '9603': 2433,
  '9604': 2433,
  '9605': 2433,
  '9606': 2433,
  '9607': 2433,
  '9608': 2433,
  '9609': 2433,
  '9610': 2433,
  '9611': 2433,
  '9612': 2433,
  '9613': 2433,
  '9709': 2441,
  '9711': 2430,
  '9884': 2404,
  '9889': 2431,
  '9890': 2431,
  '9891': 2431,
  '9892': 2431,
  '9893': 2431,
  '9894': 2431,
  '9895': 2431,
  '9896': 2431,
  '9897': 2431,
  '9898': 2431,
  '9899': 2431,
  '9900': 2431,
  '9901': 2431,
  '9902': 2431,
  '9903': 2431,
  '9904': 2431,
  '9905': 2431,
  '9906': 2431,
  '9907': 2431,
  '9908': 2431,
  '9909': 2431,
  '9910': 2431,
  '9911': 2431,
  '9912': 2431,
  '9913': 2431,
  '9914': 2431,
  '9915': 2431,
  '9916': 2431,
  '9917': 2431,
  '9918': 2431,
  '9919': 2431,
  '9920': 2431,
  '9921': 2431,
  '9922': 2431,
  '9923': 2431,
  '9924': 2431,
  '9925': 2431,
  '9926': 2431,
  '9927': 2431,
  '9928': 2431,
  '9929': 2431,
  '9930': 2431,
  '9931': 2431,
  '9932': 2431,
  '9933': 2431,
  '9934': 2431,
  '9935': 2431,
  '9936': 2431,
  '9937': 2431,
  '9938': 2431,
  '9939': 2431,
  '9941': 2431,
  '9942': 2446,
  '9943': 2446,
  '9944': 2446,
  '9945': 2446,
  '9946': 2447,
  '9947': 2429,
  '9948': 2446,
  '9949': 2446,
  '9950': 2446,
  '9951': 2446,
  '9952': 2446,
  '9953': 2446,
  '9954': 2446,
  '9955': 2446,
  '9956': 2429,
  '9957': 2447,
  '9958': 2429,
  '9959': 2445,
  '9960': 2429,
  '9961': 2446,
  '9962': 2429,
  '9963': 2447,
  '9964': 2429,
  '9965': 2445,
  '9966': 2429,
  '9967': 2446,
  '9968': 2429,
  '9969': 2447,
  '9970': 2429,
  '9971': 2445,
  '9972': 2429,
  '9973': 2446,
  '9974': 2446,
  '9975': 2446,
  '9976': 2446,
  '9977': 2446,
  '9978': 2446,
  '9979': 2446,
  '9980': 2446,
  '9981': 2446,
  '9982': 2446,
  '9983': 2446,
  '9984': 2446,
  '9985': 2446,
  '9986': 2429,
  '9987': 2429,
  '9988': 2446,
  '9989': 2446,
  '9990': 2446,
  '9991': 2446,
  '9992': 2446,
  '9998': 2410,
  '9999': 2410,
  '10003': 2431,
  '10004': 2431,
  '10005': 2431,
  '10006': 2431,
  '10007': 2431,
  '10008': 2431,
  '10009': 2431,
  '10010': 2431,
  '10011': 2432,
  '10012': 2432,
  '10014': 2432,
  '10015': 2432,
  '10017': 2432,
  '10018': 2432,
  '10028': 2442,
  '10030': 2443,
  '10041': 2431,
  '10042': 2431,
  '10043': 2431,
  '10044': 2431,
  '10045': 2431,
  '10046': 2431,
  '10047': 2431,
  '10048': 2431,
  '10049': 2431,
  '10050': 2431,
  '10051': 2432,
  '10052': 2432,
  '10053': 2432,
  '10054': 2432,
  '10055': 2432,
  '10056': 2432,
  '10057': 2432,
  '10058': 2432,
  '10059': 2432,
  '10060': 2432,
  '10061': 2432,
  '10062': 2432,
  '10064': 2448,
  '10065': 2448,
  '10066': 2448,
  '10068': 2448,
  '10070': 2431,
  '10071': 2431,
  '10072': 2431,
  '10073': 2431,
  '10074': 2431,
  '10205': 2433,
  '10206': 2433,
  '10207': 2433,
  '10208': 2433,
  '10209': 2433,
  '10210': 2433,
  '10211': 2433,
  '10212': 2433,
  '10213': 2433,
  '10214': 2433,
  '10215': 2433,
  '10218': 2433,
  '10220': 2433,
  '10224': 2431,
  '10225': 2429,
  '10226': 2429,
  '10227': 2429,
  '10228': 2429,
  '10229': 2432,
  '10230': 2432,
  '10231': 2432,
  '10232': 2432,
  '10233': 2446,
  '10234': 2446,
  '10235': 2429,
  '10236': 2429,
  '10237': 2429,
  '10238': 2429,
  '10239': 2429,
  '10240': 2429,
  '10241': 2429,
  '10242': 2429,
  '10243': 2429,
  '10244': 2429,
  '10246': 2429,
  '10247': 2445,
  '10248': 2429,
  '10249': 2429,
  '10250': 2429,
  '10251': 2445,
  '10252': 2429,
  '10253': 2429,
  '10254': 2431,
  '10255': 2431,
  '10256': 2431,
  '10261': 2422,
  '10262': 2422,
  '10263': 2422,
  '10264': 2422,
  '10265': 2422,
  '10266': 2422,
  '10267': 2422,
  '10268': 2422,
  '10270': 2423,
  '10271': 2422,
  '10272': 2422,
  '10273': 2423,
  '10274': 2423,
  '10275': 2423,
  '10276': 2423,
  '10277': 2423,
  '10278': 2422,
  '10279': 2422,
  '10280': 2422,
  '10281': 2422,
  '10282': 2422,
  '10283': 2422,
  '10284': 2422,
  '10285': 2422,
  '10286': 2422,
  '10287': 2422,
  '10315': 2431,
  '10316': 2431,
  '10317': 2431,
  '10318': 2431,
  '10319': 2431,
  '10320': 2431,
  '10321': 2431,
  '10322': 2431,
  '10323': 2431,
  '10324': 2431,
  '10325': 2431,
  '10326': 2431,
  '10327': 2431,
  '10328': 2431,
  '10329': 2431,
  '10330': 2431,
  '10331': 2431,
  '10332': 2431,
  '10333': 2431,
  '10334': 2431,
  '10335': 2431,
  '10336': 2431,
  '10337': 2431,
  '10338': 2431,
  '10339': 2431,
  '10340': 2431,
  '10341': 2431,
  '10342': 2431,
  '10343': 2431,
  '10344': 2431,
  '10345': 2431,
  '10346': 2431,
  '10519': 2436,
  '10572': 2433,
  '10573': 2433,
  '10576': 2455,
  '10579': 2410,
  '10580': 2410,
  '10599': 2433,
  '10600': 2433,
  '10601': 2433,
  '10602': 2433,
  '10603': 2433,
  '10606': 2433,
  '10607': 2433,
  '10608': 2433,
  '10609': 2433,
  '10610': 2433,
  '10611': 2433,
  '10612': 2433,
  '10613': 2433,
  '10614': 2433,
  '10615': 2433,
  '10616': 2433,
  '10617': 2433,
  '10618': 2433,
  '10619': 2433,
  '10620': 2433,
  '10621': 2433,
  '10622': 2433,
  '10623': 2433,
  '10624': 2433,
  '10625': 2433,
  '10626': 2433,
  '10627': 2433,
  '10628': 2433,
  '10629': 2433,
  '10630': 2433,
  '10631': 2433,
  '10632': 2433,
  '10633': 2433,
  '10634': 2433,
  '10635': 2433,
  '10636': 2433,
  '10637': 2433,
  '10638': 2433,
  '10639': 2433,
  '10640': 2433,
  '10641': 2433,
  '10642': 2433,
  '10643': 2433,
  '10644': 2433,
  '10645': 2433,
  '10646': 2433,
  '10647': 2433,
  '10648': 2433,
  '10649': 2433,
  '10650': 2433,
  '10651': 2433,
  '10652': 2433,
  '10653': 2433,
  '10654': 2433,
  '10655': 2433,
  '10656': 2433,
  '10657': 2433,
  '10659': 2440,
  '10666': 2431,
  '10667': 2431,
  '10668': 2431,
  '10669': 2431,
  '10670': 2431,
  '10671': 2431,
  '10672': 2431,
  '10673': 2431,
  '10674': 2431,
  '10675': 2431,
  '10676': 2431,
  '10677': 2431,
  '10678': 2431,
  '10679': 2431,
  '10680': 2431,
  '10681': 2431,
  '10682': 2431,
  '10683': 2431,
  '10684': 2431,
  '10685': 2431,
  '10686': 2431,
  '10687': 2431,
  '10688': 2431,
  '10689': 2431,
  '10690': 2431,
  '10691': 2431,
  '10692': 2431,
  '10697': 2433,
  '144893': 2438,
  '144902': 2437,
  '144903': 2410,
  '144904': 2410,
  '144905': 2410,
  '144906': 2410,
  '144907': 2410,
  '144908': 2410,
  '144913': 2454,
  '144921': 2411,
  '144922': 2411,
  '144923': 2411,
  '144945': 2411,
  '247267': 2432,
  '247276': 2432,
  '247280': 2432,
  '247340': 2429,
  '248011': 2433,
  '9545': 2403,
  '9546': 2418,
  '9547': 2419,
  '248101': 2433,
  '248603': 2410,
  '248635': 2411,
  '248652': 2433,
  '248653': 2410,
  '680001': 2433,
  '690001': 2439,
  '705001': 2431,
  '710001': 2429,
  '740001': 2431,
  '795001': 2429,
  '820001': 2429,
  '865001': 2454,
  '885003': 2431,
  '1110002': 2448,
  '1110003': 2448,
  '1110005': 2429,
  '1125001': 2429,
  '1160001': 2432,
  '1160002': 2432,
  '1170001': 2429,
  '1195001': 2446,
  '1220001': 2429,
  '1405001': 2433,
  '1405003': 2433,
  '1405004': 2433,
  '1405005': 2433,
  '1405006': 2433,
  '1405008': 2433,
  '1405009': 2433,
  '2155001': 2411,
  '2772501': 2431,
  commerce1: 2406,
  commerce2: 2408,
  commerce3: 2409,
  commerce4: 2412,
  commerce5: 2413,
  commerce6: 2414,
  commerce7: 2415,
  commerce8: 2416,
  commerce9: 2424,
  commerce14: 2434,
  commerce15: 2435,
  MILES: 2454,
  commerce17: 2449,
  commerce13: 2456,
  commerce10: 2452
};

export const idByCategory = {
  checking: [9545, 1394, 1379, 7972, 1601, 1373, 1379, 111],
  savings: [9547, 7973, 1390, 9546, 1363],
  cd: [
    1397,
    1398,
    1399,
    1400,
    1401,
    1402,
    1403,
    1404,
    1405,
    1406,
    1407,
    1408,
    1410,
    1411,
    1413,
    1415,
    1417,
    1419,
    1421,
    1424,
    1425,
    1426,
    1427,
    1428,
    1429,
    1431,
    1453,
    1456,
    1459,
    1462,
    1465,
    1468,
    1471,
    1474,
    1477,
    1478,
    1481,
    1484,
    1506,
    1509,
    1510,
    1517,
    1520,
    1521,
    1528,
    1531,
    1534,
    1537,
    1540,
    1543,
    1546,
    1549,
    1552,
    1555,
    1558,
    1561,
    1564,
    1567,
    1570,
    1573,
    1576,
    1579,
    1582,
    1585,
    1588,
    1591,
    1594,
    1597,
    1622,
    1623,
    1625,
    1627,
    1629,
    1630,
    1631,
    1632,
    1633,
    1634,
    2003,
    2004,
    2005,
    2006,
    2008,
    2009,
    2010,
    2011,
    2012,
    2013,
    2014,
    2015,
    7916,
    7922,
    7923,
    7924,
    7925,
    7926,
    7927,
    7928,
    7929,
    7983,
    7984,
    8174,
    8175,
    8178,
    8179,
    8207,
    8218,
    8219,
    8770,
    8771,
    9265,
    9266,
    9389,
    9400,
    9402,
    9403,
    9404,
    9409,
    9424,
    9425,
    9516,
    10261,
    10262,
    10263,
    10264,
    10265,
    10266,
    10267,
    10268,
    10271,
    10272,
    10278,
    10279,
    10280,
    10281,
    10282,
    10283,
    10284,
    10285,
    10286,
    10287,
  ],
  retirement: [
    1432,
    1435,
    1438,
    1441,
    1444,
    1447,
    1485,
    1488,
    1491,
    1494,
    1497,
    1500,
    1511,
    1522,
    7917,
    8176,
    8177,
    8208,
    8772,
    8773,
    9390,
    9391,
    9399,
    10270,
    10273,
    10274,
    10275,
    10276,
    10277,
  ],
};

export default idMap;
